import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { TimezoneService } from '../services/timezone.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'timezoneDate',
  pure: false,
  standalone: true
})
export class TimezoneDatePipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;
  // Impure pipe: transform() runs every change-detection cycle for every cell.
  // A multi-entry cache keyed by (value|format) means each row's moment.tz().format()
  // runs once and every subsequent cycle is an O(1) Map lookup. The whole cache is
  // dropped when the timezone preference changes so toggling stays correct.
  private cache = new Map<string, string>();

  constructor(private timezoneService: TimezoneService) {
    this.subscription = this.timezoneService.getTimezoneConfig().subscribe(() => {
      this.cache.clear();
    });
  }

  transform(value: string | Date | null | undefined, format?: string): string {
    if (!value) {
      return '';
    }

    const formatToUse = format || 'MMM D, YYYY, h:mm:ss A';
    const key = `${value instanceof Date ? value.getTime() : value}|${formatToUse}`;

    const cached = this.cache.get(key);
    if (cached !== undefined) {
      return cached;
    }

    const formatted = this.timezoneService.formatDate(value, formatToUse);
    // Bound the cache so paging through many rows can't grow it without limit.
    if (this.cache.size >= 2000) {
      this.cache.clear();
    }
    this.cache.set(key, formatted);
    return formatted;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
